import { createAppAsyncThunk } from '../store/extensions';
import { CreateMoodDto, GetMoodsDto } from './dtos';
import { GetMoodsCallType } from './model/GetMoodsCallType';
import { createMoodCall, getMoodsCall } from './service';

export const getMoods = createAppAsyncThunk(
  'moodTracker/getMoods',
  (arg: { moodsDto: GetMoodsDto; type: GetMoodsCallType; clientAction?: string }) => {
    return getMoodsCall(arg.moodsDto, arg.clientAction);
  }
);

export const createMood = createAppAsyncThunk(
  'moodTracker/createMood',
  (arg: CreateMoodDto | { moodDto: CreateMoodDto; clientAction?: string }) => {
    const moodDto = 'moodDto' in arg ? arg.moodDto : arg;
    const clientAction = 'moodDto' in arg ? arg.clientAction : undefined;
    return createMoodCall(moodDto, clientAction);
  }
);
